// AI Generated Component
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'page-details-section-inventory',
    standalone: false,
    template: `
<div id="page-details-inventory" class="row align-items-stretch">
    <div class="col-16 col-md-12 col-lg-10 col-lg-8 page-details-sitemenu border-right pr-0">
        <ul class="sidebar-nav">
            <li>
                <a [ngClass]="{'active': active === 'dashboard'}"
                   data-test="summary"
                   class="section-header mt-0"
                   [attr.aria-label]="'Summary' | translate"
                   monEventTrigger="actionTrigger"
                   [monEventParams]="{action: 'page-details-inventory-dashboard'}"
                   (click)="active = 'dashboard';">
                    <span [ngClass]="['SIDEMENUES', 'INVENTORY', 'SUMMARY'] | monIcons"
                          class="fa-fw mr-2"
                          aria-hidden="true">
                    </span>
                    <span translate>Summary</span>
                </a>
            </li>
            <li>
                <div class="ml-4 section-header" translate>Content</div>
            </li>
            <li>
                <a [ngClass]="{'active': active === 'spreadsheet'}"
                   class="link"
                   data-test="spreadsheets"
                   monEventTrigger="actionTrigger"
                   [monEventParams]="{action: 'page-details-inventory-spreadsheets'}"
                   [attr.aria-label]="'Spreadsheets' | translate"
                   (click)="active = 'spreadsheet'">
                    <span class="fas fa-fw mr-2 fa-table" aria-hidden="true"></span> <span translate>Spreadsheets</span>
                </a>
            </li>
            <li>
                <a [ngClass]="{'active': active === 'pdf'}"
                   class="link"
                   data-test="pdf"
                   monEventTrigger="actionTrigger"
                   [monEventParams]="{action: 'page-details-inventory-PDF'}"
                   [attr.aria-label]="'PDF' | translate"
                   (click)="active = 'pdf'">
                    <span class="fas fa-fw mr-2 fa-file-pdf" aria-hidden="true"></span> <span translate>PDF</span>
                </a>
            </li>
            <li>
                <a [ngClass]="{'active': active === 'archive'}"
                   class="link"
                   data-test="archived-files"
                   monEventTrigger="actionTrigger"
                   [monEventParams]="{action: 'page-details-inventory-archive'}"
                   [attr.aria-label]="'Archive files' | translate"
                   (click)="active = 'archive'">
                    <span class="fas fa-fw mr-2 fa-file-archive" aria-hidden="true"></span> <span translate>Archive files</span>
                </a>
            </li>
            <li>
                <a [ngClass]="{'active': active === 'document'}"
                   class="link"
                   data-test="text-documents"
                   monEventTrigger="actionTrigger"
                   [monEventParams]="{action: 'page-details-inventory-text-doc'}"
                   [attr.aria-label]="'Text documents' | translate"
                   (click)="active = 'document'">
                    <span class="fas fa-fw mr-2 fa-file-alt" aria-hidden="true"></span> <span translate>Text documents</span>
                </a>
            </li>
            <li>
                <a [ngClass]="{'active': active === 'slide'}"
                   class="link"
                   data-test="slides"
                   monEventTrigger="actionTrigger"
                   [monEventParams]="{action: 'page-details-inventory-slide'}"
                   (click)="active = 'slide'">
                    <span class="fa-fw mr-2" [ngClass]="['TABS', 'PAGES', 'SLIDE'] | monIcons" aria-hidden="true"></span> <span translate>Slides</span>
                </a>
            </li>
            <li>
                <a [ngClass]="{'active': active === 'file'}"
                   class="link"
                   data-test="other-files"
                   monEventTrigger="actionTrigger"
                   [monEventParams]="{action: 'page-details-inventory-other'}"
                   [attr.aria-label]="'Other files' | translate"
                   (click)="active = 'file'">
                    <span class="fas fa-fw mr-2 fa-file" aria-hidden="true"></span> <span translate>Other files</span>
                </a>
            </li>
            <li>
                <a [ngClass]="{'active': active === 'image'}"
                   class="link"
                   data-test="images"
                   monEventTrigger="actionTrigger"
                   [monEventParams]="{action: 'page-details-inventory-images'}"
                   [attr.aria-label]="'Images' | translate"
                   (click)="active = 'image'">
                    <span class="fas fa-fw mr-2 fa-file-image" aria-hidden="true"></span> <span translate>Images</span>
                </a>
            </li>
            <!--<li>-->
            <!--<a [ngClass]="{'active': active === 'inline_image'}" (click)="active = 'inline_image'"> --> <!-- receives a 500 error from the api, so this isn't gonna be used yet -->
            <!--<span class="fas fa-fw mr-2 fa-image"></span> {{ 'Inline images' | translate}}-->
            <!--</a>-->
            <!--</li>-->
            <li>
                <a [ngClass]="{'active': active === 'links'}"
                   class="link"
                   data-test="outgoing-links"
                   monEventTrigger="actionTrigger"
                   [monEventParams]="{action: 'page-details-inventory-outgoing-links'}"
                   [attr.aria-label]="'Outgoing links' | translate"
                   (click)="active = 'links'">
                    <span class="fas fa-fw mr-2 fa-sign-out-alt" aria-hidden="true"></span> <span translate>Outgoing links</span>
                </a>
            </li>
            <li>
                <a [ngClass]="{'active': active === 'incominglinks'}"
                   class="link"
                   data-test="incoming-links"
                   monEventTrigger="actionTrigger"
                   [monEventParams]="{action: 'page-details-inventory-incoming-links'}"
                   [attr.aria-label]="'Incoming links' | translate"
                   (click)="active = 'incominglinks'">
                    <span class="fas fa-fw mr-2 fa-sign-in-alt" aria-hidden="true"></span> <span translate>Incoming links</span>
                </a>
            </li>
            <li>
                <div class="outer-l section-header" translate>Technical</div>
            </li>
            <li>
                <a [ngClass]="{'active': active === 'form'}"
                   class="link"
                   data-test="forms"
                   monEventTrigger="actionTrigger"
                   [monEventParams]="{action: 'page-details-inventory-forms'}"
                   [attr.aria-label]="'Forms' | translate"
                   (click)="active = 'form'">
                    <span class="fas fa-fw mr-2 fa-bars" aria-hidden="true"></span> <span translate>Forms</span>
                </a>
            </li>
            <li>
                <a [ngClass]="{'active': active === 'headlinks'}"
                   class="link"
                   data-test="headlinks"
                   monEventTrigger="actionTrigger"
                   [monEventParams]="{action: 'page-details-inventory-headlinks'}"
                   [attr.aria-label]="'Headlinks' | translate"
                   (click)="active = 'headlinks'">
                    <span class="fas fa-fw mr-2 fa-link" aria-hidden="true"></span> <span translate>Headlinks</span>
                </a>
            </li>
            <li>
                <a [ngClass]="{'active': active === 'iframe'}"
                   class="link"
                   data-test="iframes"
                   monEventTrigger="actionTrigger"
                   [monEventParams]="{action: 'page-details-inventory-Iframes'}"
                   [attr.aria-label]="'IFrames' | translate"
                   (click)="active = 'iframe'">
                    <span class="fas fa-fw mr-2 fa-code" aria-hidden="true"></span> <span translate>IFrames</span>
                </a>
            </li>
            <li>
                <a [ngClass]="{'active': active === 'frame'}"
                   class="link"
                   data-test="frames"
                   monEventTrigger="actionTrigger"
                   [monEventParams]="{action: 'page-details-inventory-frames'}"
                   [attr.aria-label]="'Frames' | translate"
                   (click)="active = 'frame'">
                    <span class="fas fa-fw mr-2 fa-code" aria-hidden="true"></span> <span translate>Frames</span>
                </a>
            </li>
            <li>
                <a [ngClass]="{'active': active === 'css'}"
                   class="link"
                   data-test="css"
                   monEventTrigger="actionTrigger"
                   [monEventParams]="{action: 'page-details-inventory-css'}"
                   [attr.aria-label]="'CSS' | translate"
                   (click)="active = 'css'; $event.preventDefault()">
                    <span class="fab fa-fw mr-2 fa-css3" aria-hidden="true"></span> <span translate>CSS</span>
                </a>
            </li>
            <li>
                <a [ngClass]="{'active': active === 'js'}"
                   class="link"
                   data-test="js"
                   monEventTrigger="actionTrigger"
                   [monEventParams]="{action: 'page-details-inventory-js'}"
                   [attr.aria-label]="'JS' | translate"
                   (click)="active = 'js'">
                    <span class="fab fa-fw mr-2 fa-js-square" aria-hidden="true"></span> <span translate>JS</span>
                </a>
            </li>
            <li>
                <a [ngClass]="{'active': active === 'metadata'}"
                   class="link"
                   data-test="metadata"
                   monEventTrigger="actionTrigger"
                   [monEventParams]="{action: 'page-details-inventory-meta'}"
                   [attr.aria-label]="'Metadata' | translate"
                   (click)="active = 'metadata'">
                    <span class="fas fa-fw mr-2 fa-info" aria-hidden="true"></span> <span translate>Metadata</span>
                </a>
            </li>
            <li>
                <a [ngClass]="{'active': active === 'header'}"
                   class="link"
                   data-test="Headers"
                   monEventTrigger="actionTrigger"
                   [monEventParams]="{action: 'page-details-inventory-headers'}"
                   [attr.aria-label]="'Headers' | translate"
                   (click)="active = 'header'">
                    <span class="fas fa-fw mr-2 fa-heading" aria-hidden="true"></span> <span translate>Headers</span>
                </a>
            </li>
            <li>
                <div class="outer-l section-header" translate>Personal</div>
            </li>
            <li>
                <a [ngClass]="{'active': active === 'emails'}"
                   class="link"
                   data-test="email-address"
                   monEventTrigger="actionTrigger"
                   [monEventParams]="{action: 'page-details-inventory-emails'}"
                   [attr.aria-label]="'Emails' | translate"
                   (click)="active = 'emails'">
                    <span class="fas fa-fw mr-2 fa-envelope" aria-hidden="true"></span> <span translate>Email addresses</span>
                </a>
            </li>
        </ul>
    </div>
    <div class="col-32 col-md-36 col-lg-38 bg-light-grey">
        <page-details-section-inventory-dashboard *ngIf="active === 'dashboard'"
                                              [page]="page"
                                              (onGoToSection)="goToActive($event.section)">
        </page-details-section-inventory-dashboard>
        <page-details-section-inventory-incominglinks
                [pageObj]="page"
                *ngIf="active === 'incominglinks'">
        </page-details-section-inventory-incominglinks>
        <page-details-section-inventory-links
                [headline]="'Outgoing links' | translate "
                icon="fas fa-sign-out-alt"
                type="link"
                [pageObj]="page"
                *ngIf="active === 'links'">
        </page-details-section-inventory-links>
        <page-details-section-inventory-links
                [headline]="'Headlinks' | translate "
                icon="fas fa-link"
                type="headlink"
                [pageObj]="page"
                *ngIf="active === 'headlinks'">
        </page-details-section-inventory-links>
        <page-details-section-inventory-links
                [headline]="'Email addresses' | translate "
                icon="fas fa-envelope"
                type="email"
                [pageObj]="page"
                *ngIf="active === 'emails'">
        </page-details-section-inventory-links>
        <page-details-section-inventory-links
                [headline]="'Images' | translate "
                icon="fas fa-image"
                type="image"
                [pageObj]="page"
                *ngIf="active === 'image'">
        </page-details-section-inventory-links>
        <page-details-section-inventory-links
                [headline]="'PDF' | translate "
                icon="fas fa-file-pdf"
                type="pdf"
                [pageObj]="page"
                *ngIf="active === 'pdf'">
        </page-details-section-inventory-links>
        <page-details-section-inventory-links
                [headline]="'Text documents' | translate "
                icon="fas fa-file-alt"
                type="document"
                [pageObj]="page"
                *ngIf="active === 'document'">
        </page-details-section-inventory-links>
        <page-details-section-inventory-links
                [headline]="'Slides' | translate "
                [icon]="['TABS', 'PAGES', 'SLIDE'] | monIcons"
                type="slide"
                [pageObj]="page"
                *ngIf="active === 'slide'">
        </page-details-section-inventory-links>
        <page-details-section-inventory-links
                [headline]="'Spreadsheets' | translate "
                icon="fas fa-table"
                type="spreadsheet"
                [pageObj]="page"
                *ngIf="active === 'spreadsheet'">
        </page-details-section-inventory-links>
        <page-details-section-inventory-links
                [headline]="'Other files' | translate "
                icon="fas fa-file"
                type="file"
                [pageObj]="page"
                *ngIf="active === 'file'">
        </page-details-section-inventory-links>
        <page-details-section-inventory-metadata
                [pageObj]="page"
                *ngIf="active === 'metadata'">
        </page-details-section-inventory-metadata>

        <page-details-section-inventory-header
                [pageObj]="page"
                *ngIf="active === 'header'">
        </page-details-section-inventory-header>

        <!--<pageDetailsSectionInventoryLinks-->
        <!--[pageObj]="page"-->
        <!--icon="picture-o"-->
        <!--type="inline_image"-->
        <!--*ngIf="active === 'inline_image'">-->
        <!--</pageDetailsSectionInventoryLinks>-->
        <page-details-section-inventory-links
                [headline]="'CSS' | translate"
                [pageObj]="page"
                icon="fab fa-css3"
                type="css"
                *ngIf="active === 'css'">
        </page-details-section-inventory-links>
        <page-details-section-inventory-links
                [headline]="'JS' | translate"
                [pageObj]="page"
                icon="fab fa-js-square"
                type="js"
                *ngIf="active === 'js'">
        </page-details-section-inventory-links>
        <page-details-section-inventory-links
                [headline]="'Forms' | translate"
                [pageObj]="page"
                icon="fas fa-bars"
                type="form"
                *ngIf="active === 'form'">
        </page-details-section-inventory-links>
        <page-details-section-inventory-links
                [headline]="'IFrames' | translate"
                [pageObj]="page"
                icon="fas fa-code"
                type="iframe"
                *ngIf="active === 'iframe'">
        </page-details-section-inventory-links>
        <page-details-section-inventory-links
                [headline]="'Frames' | translate"
                [pageObj]="page"
                icon="fas fa-code"
                type="frame"
                *ngIf="active === 'frame'">
        </page-details-section-inventory-links>
        <page-details-section-inventory-links
                [headline]="'Archive files' | translate"
                [pageObj]="page"
                icon="fas fa-file-archive"
                type="archive"
                *ngIf="active === 'archive'">
        </page-details-section-inventory-links>
    </div>
</div>
    `,
})
export class PageDetailsSectionInventoryComponent implements OnInit {
    @Input() page: any;
    @Input() active: any;

    ngOnInit (): void {
        this.active = this.selectInventorySection();
        this.page = this.page || {};
    }

    selectInventorySection (): string {
        const sections = [
            'spreadsheet',
            'pdf',
            'archive',
            'document',
            'file',
            'image',
            'links',
            'incominglinks',
            'form',
            'headlinks',
            'iframe',
            'frame',
            'css',
            'js',
            'metadata',
            'header',
            'emails',
        ];
        const index = sections.indexOf(this.active);
        if (index === -1) {
            return 'dashboard';
        }
        return sections[index];
    }

    goToActive (active: string): void {
        this.active = active;
    }
}
